var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import GLRelatedRegistryBase from "grimoirejs-fundamental/ref/Resource/GLRelatedRegistryBase";
import MaterialFactory from "grimoirejs-fundamental/ref/Material/MaterialFactory";
import DefaultPBRMetallicRoughnessInstanciator from "./DefaultPBRMetallicRoughnessInstanciator";
export default class GLTFMaterialInstanciatorRegistry extends GLRelatedRegistryBase {
    constructor(gl) {
        super();
        this.gl = gl;
    }
    static get(gl) {
        return this.__get(gl, GLTFMaterialInstanciatorRegistry);
    }
    getInstanciator(materialData, textures, gltfData, parser) {
        return __awaiter(this, void 0, void 0, function* () {
            const matFactory = MaterialFactory.get(this.gl);
            for (let i = 0; i < GLTFMaterialInstanciatorRegistry.instanciators.length; i++) {
                const instanciator = GLTFMaterialInstanciatorRegistry.instanciators[GLTFMaterialInstanciatorRegistry.instanciators.length - 1 - i];
                const material = yield instanciator.tryInstanciate(matFactory, materialData, textures, gltfData, parser);
                if (material) {
                    return material;
                }
            }
            throw new Error("Can't find any material for specified model." + JSON.stringify(materialData));
        });
    }
}
GLTFMaterialInstanciatorRegistry.instanciators = [new DefaultPBRMetallicRoughnessInstanciator()];
GLTFMaterialInstanciatorRegistry.registryName = "gltf-material-instanciator";



// WEBPACK FOOTER //
// ./src/Parser/MaterialInstanciator/GLTFMaterialInstanciatorRegistry.ts